import React, { SetStateAction, useRef, useState } from "react";
import styleClasses from "../../../containers/try2/try2.module.scss";
import { Col, Row } from "react-bootstrap";
import ComboSection from "../../Molecules/Card/ComboSection/ComboSection";
import ItemSelectionModal from "./ItemSelectionModal";
import { ADD_ONS, BUCKET_MODIFIERS_KEY, COMPLIMENTARY_MODIFIER, KIDS_COMBO, MAKE_A_SELECTION, REACT_APP_CLOUD_FRONT, REQUIRED_MODIFIERS } from "../../../constants";
import { ISelectedItem } from "../../../models/try2Combo";
import { removeTemporarilyAddedPriceForItem, removeTry2ComboCategory, updatePriceForItem, updateTry2ComboSelectedModifiers } from "../../../redux/slices/itemCustomizationSlice";
import { useAppDispatch } from "../../../redux/store/store";
import { calculatePriceForItem } from "../../../priceCalculation/calculatePrice";
import { itemBuckets } from "../../../priceCalculation/buckets";
import { ADDITIONAL_ADDED } from "../../../priceCalculation/constants";
import { calculateCalories, currentSelectedItem, getCurrentSelectedModifierFromAPI } from "../../../helpers/combo/kidsCombo/kidsComboHelper";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";
import { IKidsComboSelectionData } from "../../../models/kidsCombo";
import _clonedeep from 'lodash.clonedeep'

interface ISelectionItemProps {
  order: any,
  selectionData: IKidsComboSelectionData[],
  itemData: any,
  location_id:string
}

const ItemSelection: React.FC<ISelectionItemProps> = ({ order, selectionData, itemData, location_id }) => {
  const dispatchItemCustomization = useAppDispatch();
  const copyOfSelectedItemModifiers = useRef(null);
  const [selectedItemId, setSelectedItemId] = useState(selectionData[0].id);

  const [isCustomize, setIsCustomize] = useState<boolean>(false)

  const [chosseitem, setChosseitem] = useState<boolean>(false);
  const [forceRender, setForceRender] = useState<boolean>(false);

  const isItMobile = useCheckMobileScreen();
  
  const chooseHandleClose = () => {
    const selectedItem = order?.modifiers?.find((item) => item?.item === selectedItemId)
    if(!selectedItem?.is_selected && !selectedItem?.modifiers?.length)
    {
      setChosseitem(false)
      return
    }
    dispatchItemCustomization(
      removeTemporarilyAddedPriceForItem({
        price: itemBuckets.discardBucketChanges(selectedItemId),
        item: selectedItemId,
      })
    );
    dispatchItemCustomization(
      updateTry2ComboSelectedModifiers({
        itemModifiers: copyOfSelectedItemModifiers.current,
        itemId: selectedItemId,
      })
    );
    copyOfSelectedItemModifiers.current = null;
    setIsCustomize(false)
    setChosseitem(false)
  };

  const chosehandleShow = () => {
    if(location_id){
      itemBuckets.createBucketCopy()
      copyOfSelectedItemModifiers.current = _clonedeep(order?.modifiers?.[Number(selectedItemId)-1]?.modifiers)
      setChosseitem(true)
    }
  };

  const findSelectedItemAvailability = (find_id) => {
    const items = order.modifiers.filter((obj) => {
      return obj.is_selected;
    });
    return items.find((item) => item.item === find_id);
  };

  const handleIngredientSelection: (data: any, id?: string) => void = (
    data,
    id = selectedItemId
  ) => {
    const item_id: 1|2|3 = parseInt(id) as 1|2|3;
    const { itemId, activeBucket, itemModifiers } = calculatePriceForItem(
      {
        currentModifier: data,
        item_id
      }
    );  
    dispatchItemCustomization(updateTry2ComboSelectedModifiers({ itemModifiers, itemId }));
    if (activeBucket !== undefined) {
      dispatchItemCustomization(updatePriceForItem({ itemId, activeBucket }));
    }
    setForceRender(!forceRender);
  };


  let showItemSelectionModal = true;
  order?.modifiers.forEach(modifier => {
    if (modifier.item === selectedItemId && modifier.is_selected && !isCustomize) showItemSelectionModal = false
  });
  
  const onRemoveClickHandler = (id) => {
    dispatchItemCustomization(removeTry2ComboCategory({ id }));
  };

  const onEditClickHandler = (name, id) => {
    setIsCustomize(true)
    chosehandleShow()
  }

  const onSectionSelection = (id) => {
    if(location_id){
      setSelectedItemId(id)
    }
  }

  const selectedItem = (section:IKidsComboSelectionData) => {
    const selected: ISelectedItem = findSelectedItemAvailability(section?.id);
    const modifiersAsItems:any = parseInt(section?.id) < 3
      ? itemData?.items_modifier_groups[0]?.modifiers_groups_modifiers
      : itemData?.items_modifier_groups[1]?.modifiers_groups_modifiers
    // ? Get selected Item
    return currentSelectedItem(modifiersAsItems, selected, section.id);
  }

  const columnClickHandler = (sectionId:SetStateAction<string>):void => {
      setSelectedItemId(sectionId);
      chosehandleShow();
  }

  const itemCalories = (item,sectionId:string) => {
    const fromItem: 0|1|2 = parseInt(sectionId) - 1 as 0|1|2;
    const AddOns = itemBuckets.getSingleBucketKeyValue({name:ADD_ONS,fromItem,modifierType: ADDITIONAL_ADDED,key:BUCKET_MODIFIERS_KEY})
    const Complementary = itemBuckets.getSingleBucketKeyValue({name:COMPLIMENTARY_MODIFIER,fromItem,modifierType:ADDITIONAL_ADDED,key:BUCKET_MODIFIERS_KEY})
    return item?.calories + calculateCalories(AddOns) + calculateCalories(Complementary)
  }

  const nameOnCard = (item: any, section: IKidsComboSelectionData) => {
    if (item?.name) {
      return item.name;
    }
    if (isItMobile) {
      return section.sm_title;
    }
    if (section.showCustomTitle) {
      return section.customTitle;
    }
    return MAKE_A_SELECTION;
  }

  return (
    <Row className={`${styleClasses.kids_combo_row} my-4 pb-md-0 pb-2`}>
      {selectionData.map((section) => {
        const item = selectedItem(section)
        return (
          <Col
            onClick={() => columnClickHandler(section?.id)}
            key={section.id}
            className={`${styleClasses.kids_combo_item}`}
          >
            <ComboSection
              id={section.id}
              title={isItMobile ? section.sm_title : section.title}
              onChange={(id) => onSectionSelection(id)}
              image={item?.image ? `${REACT_APP_CLOUD_FRONT}${item.image}` : ""}
              itemName={nameOnCard(item,section)}
              changeItemSize={item?.name ? "" : "f-s18"}
              selectedItem={selectedItemId}
              isItemSelected={Boolean(item)}
              textStart={"text-start"}
              weight={itemCalories(item, section?.id)}
              comingFromItem={KIDS_COMBO}
              onRemoveClickHandler={onRemoveClickHandler}
              onEditClickHandler={onEditClickHandler}
              kidComboItemDefaultName={isItMobile ? section.sm_title : section.showCustomTitle ? section.customTitle : MAKE_A_SELECTION}
            />
          </Col>
        )
      })}
      { showItemSelectionModal &&
        <ItemSelectionModal
          isCustomize={isCustomize}
          selectedItemId={selectedItemId}
          selectionData={selectionData}
          itemData={itemData}
          chosseitem={chosseitem}
          setChosseItem={setChosseitem}
          setIsCustomize={setIsCustomize}
          chooseHandleClose={chooseHandleClose}
          handleIngredientSelection={handleIngredientSelection}
        />
      }
    </Row>
  );
};

export default ItemSelection;
